const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedLoyaltyTier: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const loyaltytier = (state = initialState, action) => {
	switch (action.type) {
		case 'LOYALTYTIER_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'LOYALTYTIER_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'LOYALTYTIER_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'LOYALTYTIER_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'LOYALTYTIER_GET_CURRENT':
			return {
				...state,
				selectedLoyaltyTier: action.selectedLoyaltyTier,
			}
		case 'LOYALTYTIER_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default loyaltytier
